var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterviewCanceled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 18.3337C14.6025 18.3337 18.3334 14.6027 18.3334 10.0003C18.3334 5.39795 14.6025 1.66699 10.0001 1.66699C5.39771 1.66699 1.66675 5.39795 1.66675 10.0003C1.66675 14.6027 5.39771 18.3337 10.0001 18.3337ZM8.65332 7.18042C8.24652 6.77363 7.58698 6.77363 7.18018 7.18042C6.77338 7.58722 6.77338 8.24677 7.18018 8.65356L8.52694 10.0003L7.18018 11.3471C6.77338 11.7539 6.77338 12.4134 7.18018 12.8202C7.58697 13.227 8.24652 13.227 8.65332 12.8202L10.0001 11.4735L11.3468 12.8202C11.7536 13.227 12.4132 13.227 12.82 12.8202C13.2268 12.4134 13.2268 11.7539 12.82 11.3471L11.4732 10.0003L12.82 8.65356C13.2268 8.24677 13.2268 7.58722 12.82 7.18042C12.4132 6.77363 11.7536 6.77363 11.3468 7.18042L10.0001 8.52719L8.65332 7.18042Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewCanceled);
export default __webpack_public_path__ + "static/media/interview-canceled.c970dfd802fcc852e532bb3147fe88a2.svg";
export { ForwardRef as ReactComponent };